const EssentialReading = () => import(/* webpackChunkName: "PaEssentialReading" */ "./Sections/EssentialReading.vue");
const InTheNews = () => import(/* webpackChunkName: "PaInTheNews" */ "./Sections/InTheNews.vue");
const Multimedia = () => import(/* webpackChunkName: "PaMultimedia" */ "./Sections/Multimedia.vue");
const GeneralSection = () => import(/* webpackChunkName: "PaGeneralSection" */ "./Sections/GeneralSection");
const AmericanStories = () => import(/* webpackChunkName: "PaAmericanStories" */ "./Sections/AmericanStories.vue");
const SevenEadThemes = () => import(/* webpackChunkName: "PaSevenEadThemes" */ "./Sections/SevenEadThemes.vue");
const Entrepreneurship = () => import(/* webpackChunkName: "PaEntrepreneurship" */ "./Sections/Entrepreneurship.vue");

export default {
    components: {
        'essential-reading': EssentialReading,
        'in-the-news': InTheNews,
        'multimedia': Multimedia,
        'general-section': GeneralSection,
        'american-stories': AmericanStories,
        'seven-ead-themes': SevenEadThemes,
        'entrepreneurship': Entrepreneurship,
    },
    computed: {

        hrefTarget: function() {
            return (this.issue.slug === 'state_solutions' ? "_blank" : "_self");
        },
    },
    methods: {

        getThemeContentButtons(){
            return 'seven-ead-themes'
        },

        getSectionComponent(section){
            
            /**
             * Have each section, no matter how many there are, function and look like the "Essential Reading" section typically does. No matter what they are named.
             */
            if(['entrepreneurship','realclearunicorns'].indexOf(this.issue.slug) > -1){
                return 'entrepreneurship';
            }

            switch (section.slug) {
                case 'essential_reading':
                    return 'essential-reading';
                case 'in_the_news':
                    return 'in-the-news';
                case 'multimedia':
                    return 'multimedia';
                case 'american_stories':
                    return 'american-stories';
                case 'seven_themes':
                case 'seven_ead_themes':
                    return 'seven-ead-themes';
                default:
                    return 'general-section';
            }
        },

        replace_image_size: function (img_url) {

            if (!img_url || img_url == null || typeof img_url === 'undefined') {
                return ''
            }

            return img_url.replace('_1_', '_4_')
        },

        openCarlCannonsAuthorPage() {
            window.open('https://www.realclearpublicaffairs.com/authors/carl_m_cannon/', '_blank')
        },
    },
}